module.exports = __webpack_public_path__ + "static/media/chosing-illustration.72b7059f.svg";